export default "__VITE_ASSET__BwzWCHM9__"